import {
    scrollToPreviousNextCard,
    tryRestoreLastScrollPositionAzm,
} from "@modules/tracking/previous-next-advert-cookie.ts"
import { BaseEvent } from "./BaseEvent"

/*
scrolling.js

Diese Datei ist für das Scrolling zu der richtigen Seitenposition zuständig.
 */

class ScrollingClass {
    siteScrolled: BaseEvent
    siteWasScrolledToPosition: number

    constructor() {
        this.siteScrolled = new BaseEvent(this)

        this.siteWasScrolledToPosition = 0

        $(window).on("beforeunload", () => {
            if ("scrollRestoration" in history) {
                history.scrollRestoration = "auto"
            }
        })

        //scroll to animationen stoppen wenn user scrollt.
        $("html, body").on("scroll mousedown wheel DOMMouseScroll wheel keyup touchmove", () => {
            $("html, body").stop(false, true)
        })

        // Scroll
        $(window).on(
            "scroll",
            function (this: ScrollingClass) {
                clearTimeout($.data(this, "scrollTimer"))

                $.data(
                    this,
                    "scrollTimer",
                    setTimeout(
                        function (this: ScrollingClass) {
                            this.notifySiteScrolled()
                        }.bind(this),
                        250,
                    ),
                )
            }.bind(this),
        )

        const previousNextIdKey = `scrollToPreviousNextId_${SiteInfo.controller}_${SiteInfo.advertId}`
        const prevNextId = localStorage.getItem(previousNextIdKey)

        if (prevNextId) {
            localStorage.removeItem(previousNextIdKey)
            scrollToPreviousNextCard(prevNextId)
            return
        }

        if (tryRestoreLastScrollPositionAzm()) {
            return
        }
    }

    /**
     * @private
     */
    notifySiteScrolled() {
        this.siteScrolled.notify({
            debug: "siteScrolled",
            position: $(document).scrollTop(),
        })
    }
}

export const Scrolling = new ScrollingClass()
